// THE MAIN URL FOR THE API

const hostName = window.location.hostname;
const online =
  hostName.toLowerCase() === 'snapcap-transfer-center-dev.8byteslab.com' ||
    hostName.toLowerCase() === 'center.snap-drive.net' ||
hostName.toLowerCase() === 'center-stg.snap-drive.net';
const scheme = window.location.protocol;
let MAIN_HOST, SOCKET_HOST, PRODUCTION_WARNING;

if (!online) {
  MAIN_HOST = `http://${hostName}:8000`;
  SOCKET_HOST = `http://${hostName}:3000/`;
} else if (hostName.toLowerCase() === "snapcap-transfer-center-dev.8byteslab.com") {
  MAIN_HOST = `https://snapcap-back-dev.8byteslab.com`;
  SOCKET_HOST = `https://snapcap-node-dev.8byteslab.com/`;
} else if (hostName.toLowerCase() === 'center-stg.snap-drive.net') {
  MAIN_HOST = `https://api-stg.snap-drive.net`;
  SOCKET_HOST = `https://node-stg.snap-drive.net/`;
} else if (hostName.toLowerCase() === 'center.snap-drive.net') {
  MAIN_HOST = `https://api.snap-drive.net`;
  SOCKET_HOST = `https://node.snap-drive.net/`;
}else{
  MAIN_HOST = `https://snapcap-back-dev.8byteslab.com`;
  SOCKET_HOST = `https://snapcap-node-dev.8byteslab.com/`;
}


import avatar from "@/assets/avatar.jpg";
import company from "@/assets/company.png";

export const IMAGES_MAIN_URL = MAIN_HOST;

export default {
  MAIN_URL: MAIN_HOST,
  IMAGES_URL: IMAGES_MAIN_URL,
  PRODUCTION_WARNING: PRODUCTION_WARNING || false,
  GET_IMAGE(url) {
    if (url == "0" || url == null) return avatar;
    return IMAGES_MAIN_URL + "/" + (url[0] === "/" ? url.substr(1) : url);
  },
  GET_COMPANY_IMAGE(url) {
    if (url == "0" || url == null) return company;
    return IMAGES_MAIN_URL + "/" + (url[0] === "/" ? url.substr(1) : url);
  },
  GET_TERM(url) {
    if (url == "0" || url == null) return avatar;
    return IMAGES_MAIN_URL + "/storage/" + url;
  },
  ACTIONS: {
    STORAGE_LINK: "storage",
    TERMS_STORAGE_LINK: "files",
    GLOBAL_MESSAGE: "global_message",
    TERMS: "terms_captain",
    RESERVATION_QUEUE: "reservation_queue",
    BROADCAST_PRESETS: "broadcast-preset",
    BROADCAST: "broadcast",
    SUGGESTION_ALLOWED_CAPTAIN: "suggestion_allowed_captain",
    CAPTAIN_STATISTICS: "statistics/captain/all_performance",
    CAPTAIN_MONTHLY_BOOKINGS_COUNTS: "captain/monthly-bookings-counts",
    CAPTAIN_SHIFTS_STATS: "captain/shifts-stats",
    CAPTAIN_SHIFT_LOGS: "captain-shift",
    CAPTAIN_SHIFT_LOGS_AVG: "captain-shifts-avg",
    CAPTAIN_MONTHLY_BOOKINGS_STATS: "captain/captain_bookings_stats",
    CAPTAIN_ACCEPTANCE_RATIO: "statistics/captain/all_acceptance_ratio",
    DISPATCH_BOOKINGS: "booking/dispatch",
    BEESLINE_STATSTICS: "beesline/statistics",
    BEESLINE_STORE: "beesline/store",
    BEESLINE_AREA_CLUSTER: "beesline/area_cluster",
    BEESLINE_CHECK_VOUCHER: "beesline/voucher/check",
    BEESLINE_USE_VOUCHER: "beesline/voucher/use",
    LOCATION_CLUSTER: "location_cluster",
    OSM: "statistics/osm",
    BOOKINGS: "booking",
    LOGIN: "login",
    SEND_CODE: "admin_send_code",
    RESET_PASSWORD_EMAIL: "forgot_password/request",
    RESET_PASSWORD: "forgot_password/reset",
    LOGOUT: "logout",
    CHECK_TOKEN: "check_auth",
    USERS: "user",
    STAFF: "staff",
    USER_META_DETAILS: "user_meta_details",
    LOCATIONS: "location",
    AREA: "area",
    PASSENGERS: "passenger",
    CREATE_PASSENGER: "admin-passenger",
    COMPANY_REQUESTS: "company-request",
    PASSENGERS_NUMBER: "passenger_numbers",
    HOTEL: "hotel",
    RESTAURANT: "restaurant",
    payments: "payments",
    SEASONAL_RESERVATIONS: "seasonal_reservation",
    SMS_CODES: "sms-codes",
    SERVICES: "service",
    PAYMENT_METHODS: "payment-method",
    BONUS: "bonus",
    BONUS_PACKAGE: "bonus_package",
    BONUS_PACKAGE_BONUSES: (id) => `bonus_package/${id}/bonuses`,
    REGISTRATION_REQUESTS: "registration_request",
    SERVICE_PRICES: (id) => `price?service_id=` + id,
    SERVICE_CARS: (id) => `service/${id}/cars`,
    UPDATE_CAR_DATA: (id) => `car/${id}`,
    SERVICE_LOCATIONS: (id) => `service/${id}/locations`,
    RIDE: "ride",
    JOIN_RIDE: (ride_id) => `ride/${ride_id}/join`,
    ROLES: "roles",
    PERMISSIONS: "permissions",
    CAPTAINS: "captain",
    CAPTAIN_CAR: "car",
    QR_CODE: "get_qr_code",
    CAPTAIN_CARS: (captain_id) => `captain/${captain_id}/cars`,
    CAPTAIN_REQUEST_RESET_PASSWORD: "captain/request_reset",
    CAR_BRANDS: "car-brand",
    VEHICLE_TYPE: "vehicle_type",
    CAR_BRAND_MODELS: (id) => `car-brand/${id}/models`,
    COLORS: "color",
    BANKS: "bank",
    NOTES: "note",
    NATIONALITIES: "nationality",
    PHONE_VOUCHERS: "phone_voucher",
    VOUCHERS: "voucher",
    FIRST_RIDE_PAX: "customer_care/first_ride_pax",
    ANAS: "customer_care/anas_stats",
    DEMAND_PUMP: "voucher/demand_pump",
    LOGS: "log",
    RANDOM_VOUCHER: "voucher/random",
    CHECK_LOGS: "check_log",
    TIMELINE: "timeline",
    REDISPATCH_BOOKING: (bookingId) => `booking/${bookingId}/redispatch`,
    AVAILABLE_INTERVIEW_TIMES: "available_interview_time",
    INTERVIEW_SLICE: "available_interview_time/slice",
    INTERVIEW_MAX_CAPTAINS: `available_interview_time/max_captains`,
    INTERVIEW_STATUS: "interview_status",
    INTERVIEWS: "interview",
    CAPTAIN_SCHEDULE: (captainId) => `captain/${captainId}/schedule`,
    PENALTY: "penalty",
    // START SETTINGS
    SETTINGS: "setting",
    USER_CANCELLATION_REASONS: "cancellation-reason",
    CANCELLATION_REASONS: "cancellation-reason",
    CHANGE_SEASON: "setting/season",
    // END SETTINGS
    CAPTAIN_TRANSACTIONS: (captainId) => `captain/${captainId}/transactions`,
    PASSENGER_TRANSACTIONS: (passengerId) =>
      `passenger/${passengerId}/transactions`,
    LOCATION_CONTAINERS: "location_container",
    BONUSES_REQUEST: "bonus_request",
    STATISTICS: "statistic",
    STATIONS: "landmark",
    ADDRESS: "address",
    LANDMARKS: "landmark",
    PASSENGER_RATING_CAUSES: "passenger_rating_cause",
    CAPTAIN_RATING_CAUSES: "captain_rating_cause",
    PASSENGER_ID_CONVERTER: "passenger_id_converter",
    TICKETS: "ticket",
    TICKET_ASSIGN: (ticket_id) => "ticket/" + ticket_id + "/assign",
    USER_STATS: (user_id) => `user/${user_id}/stats`,
    USER_ALL_STATS: "user/stats",
    CAPTAIN_BLACKLIST_HISTORY: (id) => `captain/${id}/blacklist_log`,
    SERVICE_EXTRA_CHARGES: (service_price_id) =>
      `service_price/${service_price_id}/extra_charge`,
    CANCELLATION_TICKETS: "ticket/cancellation",
    BLACKLIST_LOCATIONS: "blacklist_location",
    LOST_CAPTAINS: "lost_captain",
    CAPTAIN_TIMELINE: (id) => `captain/${id}/timeline`,
    CAPTAINS_STATUSES_TIMELINE: "captains-timeline",
    PRESENT_CAPTAINS: `captain/weekly_present`,
    CAPTAIN_RATINGS: (id) => `captain/${id}/ratings`,
    CAPTAIN_RATING_STATS: (id) => `captain/${id}/rating_stats`,
    ALL_END_RIDES: "timeline/end_rides",
    GHOST_RIDES: "ghost_ride",
    USER_SCHEDULE: "user_schedule",
    SUGGEST_SERVICE_CHANGE: (booking_id) =>
      `booking/${booking_id}/suggest_service_change`,
    MONEY_TRANSFER: "money_transfer",
    USER_META: (user) => `user/${user}/meta`,
    GET_LOGIN_IDENTFIER: `user/identifier`,
    CAPTAIN_CANCELLATION_REASONS: "captain_cancellation_reason",
    INCOMPLETE_CAPTAIN: "incomplete_captain",
    LEAVES: "user/leave",
    UNRESOLVED_LEAVES: "unresolved_leaves",
    APPROVE_OR_REJECT_LEAVES: "leave/approve_or_reject",
    EXTRA_HOURS: "user/extra_hours",
    UNRESOLVED_EXTRA_HOURS: "unresolved_extra_hours",
    APPROVE_OR_REJECT_EXTRA_HOURS: "extra_hours/approve_or_reject",
    EMPLOYMENT_TYPE: "employment_type",
    SALARY_EVENTS: "salary_event",
    EMPLOYMENT_TYPE_DELAY_POLICY: (id) =>
      `employment_type/${id}/delay_policies`,
    EMPLOYMENT_TYPE_GENERAL_HOLIDAY: (id) =>
      `employment_type/${id}/general_holidays`,
    SALARY_REPORT: "salary_report",
    ALL_SALARY_REPORT: "/salaries_reports",
    REGENERATE_REPORT: "/salary_report/generate",
    REGENERATE_ALL_REPORTS: "salaries_reports/generate",
    USER_PROJECT_SCHEDULES: "user_project_schedule",
    PROJECT: "project",
    CREATE_HOTEL: "hotels/store",
    CREATE_COMPANY: "companies/store",
    CREATE_RESTAURANT: "restaurants/store",
    LANGUAGES: "language",
    GET_ALL_CAPTAINS: "getAllCaptains",
    GET_ALL_STATIONS: "getStations",
    GET_STATION: (id) => `stats/driver/station/${id}`,
    ALL_STATIONS: "stations",
    ADVANCED_SEARCH: "booking/search",
    EVENTS: "event",
    EVENTS_DETAILS: (id) => `event/${id}/details`,
    EVENTS_DETAILS_CAPTAINS: (id) => `event_details/${id}/captains`,
    TWILIO_TOKEN: "generate_chat_token",
    BOOKING_LOG: (id) => `booking-logs/${id}`,
    CAPTAIN_PAYMENTS: (id) => `captain/${id}/accounting`,
    SURVEYS: 'survey',
    CONSTRAINTS: 'dynamic_constraints',
    PRICE_RULES: 'priceRule',
    CAPTAIN_CHANGE_NAME_LOG: (id) => `captain/${id}/change_name_log`,
    PASSENGERS_MARKETING_PREVIEW: 'passenger/marketing/preview',
    PASSENGERS_MARKETING_SEND: 'passenger/marketing/send',
  },
  SOCKET: {
    CAPTAINS: SOCKET_HOST + "captains",
    USERS: SOCKET_HOST + "users",
    GUESTS: SOCKET_HOST + "guests",
    EVENTS: {
      CAPTAIN_UPDATED_LOCATION: "captain_location_updated",
      BOOKINGS_WERE_APPROVED: "approved_bookings",
      NEW_PENDING_BOOKING: "Timeline:new_booking",
      NEW_NOW_BOOKING: "Ai:new_now_booking",
      NEW_NOTIFICATION: "Dashboard:new_notification",
      DELETE_BOOKING: "Timeline:remove_booking",
      UPDATE_BOOKING: "Timeline:update_booking",
      NEW_ACTION: "Ride:new_action",
      LATE_BOOKING: "Dashboard:late_booking",
      LATE_CAPTAIN: "Dashboard:late_captain",
      ESTIMATED_START_LATENESS: "Dashboard:estimated_start_lateness",
      ESTIMATED_END_LATENESS: "Dashboard:estimated_end_lateness",
      UPDATE_BOOKING_STATUS: "Timeline:update_booking_status",
      UPDATE_END_RIDE: "Timeline:update_end_ride",
      NEW_TICKET: "Dashboard:new_ticket",
      DISMISS_TICKET: "Dashboard:dismiss_ticket",
      RENEW_BESOIN: "Dashboard:renew_besoin",
      EXPIRED_BESOIN: "Dashboard:expired_besoin",
    },
  },
  mapBox: {
    accessToken:
      "pk.eyJ1Ijoic25hcG1hcG8iLCJhIjoiY21wdml4MXg5MjZrczJ2cTUydDl1M2trbCJ9._uxNTkOWpxUL_bZ82t20Zg",
    style: "mapbox://styles/mapbox/streets-v10",
    center: [36.2765, 33.5138],
    zoom: 8,
  },
  CONSTANTS: {
    STATES: [
      "Latakia",
      "Idlib",
      "Aleppo",
      "Raqqa",
      "Al-Hasakah",
      "Tartus",
      "Hama",
      "Deir ez-Zor",
      "Homs",
      "Damascus",
      "Rif Dimashq",
      "Quneitra",
      "Daraa",
      "Al-Suwayda",
    ],
    WHATSAPP_NUMBERS: [
      "963965656008",
      "963954044416",
      "963965656005",
      "963966080574",
    ],
    ACCOUNT_ENTRY_TYPES: [
      "wallet_migration",
      "ride",
      "payment",
      "passenger_penalty",
      "captain_penalty",
      "closing_payment",
      "payment_approval",
      "passenger_bonus",
      "captain_bonus",
    ],
    GENDER: {
      MALE: 0,
      FEMALE: 1,
    },
    COLOR_INDICATORS: {
      PENDING: "#9f43cf",
      CONFIRMED: "#8e8e88",
      STARTED: "#428bca",
      ARRIVED: "#ffa60c",
      PICKED_UP: "#e04b4a",
      DONE: "#69b869",
      STOP: "#b3e6cc",
    },
  },
};
